/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import MyRoutes from "../src/pages/MyRoutes/MyRoutes";
import Help from "./pages/Help/Help";
import SignIn from "./pages/Authentication/SignIn";
import SignUp from "./pages/Authentication/SignUp";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import ResetPassword from "./pages/Authentication/ResetPassword";
import Cemetery from "./pages/Category/Cemetery/Cemetery";
import PlanYourTrip from "./pages/PlanYourTrip/PlanYourTrip";
import Favourites from "./pages/Favourites/Favourites";
import Points from "./pages/Points/Points";
import Detail from "./pages/Category/Cemetery/Detail/Detail";
import Routes_Detail from "./pages/MyRoutes/Detail/Routes_Detail";
import SearchCustomPoint from "./pages/SearchCustomPoint/SearchCustomPoint";
import AddMorePointsToRoute from "./pages/AddMorePointsToRoute/AddMorePointsToRoute";
import AlongTheWayToHere from "./pages/AlongTheWayToHere/AlongTheWayToHere";
import ExploreNearMe from "./pages/ExploreNearMe/ExploreNearMe";
import AlongRoute from "./pages/AlongRoute/AlongRoute";
import ExploreNearBy from "./pages/ExploreNearBy/ExploreNearBy";
import AlongwithPreviousPoint from "./pages/AlongRoutePreviousPoint/AlongwithPreviousPoint";
import SearchEverywhere from "./pages/SearchEverywhere/SearchEverywhere";
import TzadikimShareLink from "./pages/Category/Cemetery/Detail/TzadikimShareLink";
import BuyPoints from "./pages/BuyPoints/BuyPoints";
import Ads from "./pages/Ads/Ads";
import NextPlacesScreen from "./pages/NextPlaces";
import AddMorePointsToRouteDetails from "./pages/AddMorePointsToRoute/AddMorePointsToRouteDetails";

const Router = ({
  isUserLoggedIn,
  userAuthentication,
  getPoints,
  pathName,
  setUserPoints,
  userPoints,
}) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Home
            isUserLoggedIn={isUserLoggedIn}
            pathName={pathName}
            setUserPoints={setUserPoints}
            userAuthentication={userAuthentication}
            userPoints={userPoints}
          />
        }
      />
      <Route
        path="/my-routes"
        element={<MyRoutes isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route path="/help" element={<Help />} />
      <Route path="/next-places" element={<NextPlacesScreen />} />
      <Route
        path="/category-list"
        element={<Cemetery isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/plan-your-trip"
        element={<PlanYourTrip isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/favourites"
        element={<Favourites isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route path="/points" element={<Points />} />
      <Route path="/ads" element={<Ads />} />
      <Route
        path="/category-detail/"
        element={<Detail isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/my-routes-detail/:routeId/:selectedRouteName"
        element={
          <Routes_Detail
            getPoints={getPoints}
            isUserLoggedIn={isUserLoggedIn}
          />
        }
      />
      <Route
        path="/search-custom-point"
        element={<SearchCustomPoint isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/add-more-points-to-route"
        element={<AddMorePointsToRoute isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/add-more-points-to-route-category-list"
        element={
          <AddMorePointsToRouteDetails isUserLoggedIn={isUserLoggedIn} />
        }
      />
      <Route
        path="/along-the-way-to-here/:poi"
        element={
          <AlongTheWayToHere
            isUserLoggedIn={isUserLoggedIn}
            getPoints={getPoints}
          />
        }
      />
      <Route
        path="/explore-near-me"
        element={<ExploreNearMe isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/along-route"
        element={
          <AlongRoute isUserLoggedIn={isUserLoggedIn} getPoints={getPoints} />
        }
      />
      <Route
        path="/along-route-previous-point"
        element={
          <AlongwithPreviousPoint
            isUserLoggedIn={isUserLoggedIn}
            getPoints={getPoints}
          />
        }
      />
      <Route
        path="/search-everywhere"
        element={<SearchEverywhere isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/explore-near-by/:poi"
        element={<ExploreNearBy isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/category-details/:id/:poi"
        element={<TzadikimShareLink isUserLoggedIn={isUserLoggedIn} />}
      />
      <Route
        path="/buyPoints"
        element={
          <BuyPoints isUserLoggedIn={isUserLoggedIn} getPoints={getPoints} />
        }
      />
      <Route
        path="/sign-in"
        element={<SignIn userAuthentication={userAuthentication} />}
      />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
    </Routes>
  );
};

export default Router;
